declare var swal: any;
import { Component, OnInit } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal, NgbDateStruct, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgbCounsellingRegistryModal } from './modal/counsellingregistry.modal';
import { CounsellingPlanController, SaveCounsellingPlanRequest, GenericProcPostRequest, GenericParams, FTV, S_Methods, GenericCounsellingPlanRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { CounsellingPlanRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbSearchPatientModal } from './modal/searchpatient.modal';
import { NgbEditCounsellingPlanModal } from './modal/editcounsellingplan.modal';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
@Component({
  selector: 'app-counsellingregistry',
  templateUrl: './counsellingregistry.component.html',
  styleUrls: ['./counsellingregistry.component.css']
})
export class CounsellingregistryComponent implements OnInit {
  // When the user clicks on the button, scroll to the top of the document
 topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
 }
  Bottom() {
    let m = document.querySelector("#bottom");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }

  public ActorCode:string;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public ShowMonitoring: boolean = false;
  public ShowCounselling: boolean = true;
  public Showarrow: boolean = false;
  public isRequesting: boolean = false;

  DOB: NgbDateStruct;
  StartDate: NgbDateStruct;
  EndDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  searchTitle: string;

  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;

  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;


  sub: Subscription;
  CurrentCounsellingPlanController: CounsellingPlanController[];
  CurrentCounsellingPlanRequest: CounsellingPlanRequest;
  CurrentCounsellingPlanRequest_g: GenericCounsellingPlanRequest;
  CurrentEditCounsellingPlanRequest: SaveCounsellingPlanRequest;
  CurrentDeleteCounsellingPlanRequest: SaveCounsellingPlanRequest;
  LoadCounselling() {
    this.CurrentEditCounsellingPlanRequest = new SaveCounsellingPlanRequest();
    this.CurrentEditCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentCounsellingPlanRequest = new CounsellingPlanRequest();
    this.CurrentCounsellingPlanRequest.ActorCode ="";
    this.CurrentCounsellingPlanRequest.ConditionalOperator = 10;
      this.CurrentCounsellingPlanRequest.SearchText = "";
      this.CurrentCounsellingPlanRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentCounsellingPlanRequest.FromDate = new Date();
    this.CurrentCounsellingPlanRequest.ToDate = new Date();
    this.CurrentCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCounsellingPlanController();
  }
  LoadCounselling_Next() {
    // generic call to get counselling registers.. 101034
    //Actorcode, BranchCode , FormattedCode, SearchText, NextCode

    this.CurrentCounsellingPlanRequest_g = new GenericCounsellingPlanRequest();
    this.CurrentCounsellingPlanRequest_g.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentCounsellingPlanRequest_g.ConditionalOperator = 101034;
    this.CurrentCounsellingPlanRequest_g.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentCounsellingPlanRequest_g.FromDate = new Date();
    this.CurrentCounsellingPlanRequest_g.ToDate = new Date();
    this.CurrentCounsellingPlanRequest_g.ActorCode = "";
    this.CurrentCounsellingPlanRequest_g.NextCode = this.LoadedRecordsCount;
    this.CurrentCounsellingPlanRequest_g.SearchText = "";
    var str = JSON.stringify(this.CurrentCounsellingPlanRequest_g);
    this.CurrentCounsellingPlanRequest_g.ConditionalOperator = 101034;
    this.CurrentCounsellingPlanRequest_g.QueryData = str;
    this.CurrentCounsellingPlanRequest_g.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.actorservice.Save<GenericProcPostRequest>(
        this.CurrentCounsellingPlanRequest_g, S_Methods.GetGenericPost)
        .subscribe((result) => {

          this.ApiResData = result;
          if (!this.ApiResData.hasError) {
            var data: string = this.ApiResData.Result.join("");
            //alert(data);
            var nextSet: CounsellingPlanController[] = JSON.parse(data);

            // Get Results converted to array of plans.
           // var nextSet: CounsellingPlanController[] = this.ApiResData.Result;
            // add the new set of records to existing table ..
            this.CurrentCounsellingPlanController = this.CurrentCounsellingPlanController.concat(nextSet);
            // increment total loaded records count..
            this.LoadedRecordsCount = this.LoadedRecordsCount + nextSet.length;
            // if fetched records are less than 50, no more to show, hence diable next
            if (nextSet.length < this.howmanytoloadeachtime) {
              this.NextEnabled = false;
            }

            if (this.ApiResData.Result[0].length > 0) {
              //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
              this.stopRefreshing();
            }
            else {
              alertFunctions.AlertParam("Invalid Operation...!");
              this.stopRefreshing();
            }
          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {
              alert(this.ApiResData.ErrorData);
            }
            else {
              this.stopRefreshing();
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            }
          }

        },
          (error) => {

            if (error == "401 - Unauthorized") {
              alertFunctions.AlertParamEr(error);

              this.stopRefreshing();
            }
            else {
              alertFunctions.AlertParamEr(error);

              this.stopRefreshing();
            }
          }
        );

    //this.GetCounsellingPlanController();

 
  }
  NextEnabled: boolean = true;
  howmanytoloadeachtime: number = 50;
  LoadedRecordsCount: number = 0;
  RefreshPatients(st: string) {
    this.CurrentCounsellingPlanRequest = new CounsellingPlanRequest();
    this.CurrentCounsellingPlanRequest.ActorCode = "";
      this.CurrentCounsellingPlanRequest.ConditionalOperator = 15;
      this.CurrentCounsellingPlanRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentCounsellingPlanRequest.FromDate = new Date();
    this.CurrentCounsellingPlanRequest.ToDate = new Date();
    this.CurrentCounsellingPlanRequest.SearchText = st;
    this.CurrentCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetCounsellingPlanController();
  }
  _GetCounsellingPlanController() {
    this.StartRefreshing();


    this.actorservice.GetCounsellingPlanController(this.CurrentCounsellingPlanRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCounsellingPlanController = this.ApiResData.Result || (this.ApiResData as any).result || [];
          //alert(this.ApiResData.Result);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
  GetCounsellingPlanController() {
    this.NextEnabled = true;
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetCounsellingPlanController(this.CurrentCounsellingPlanRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (this.ApiResData && !this.ApiResData.hasError) {
          const rawResult = this.ApiResData.Result || (this.ApiResData as any).result || [];
          this.CurrentCounsellingPlanController = rawResult;
          this.LoadedRecordsCount = (this.CurrentCounsellingPlanController || []).length;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private modalService: NgbModal,
    private tosterservice: NGXToastrService,
    private route: ActivatedRoute,
    private actorservice: ActorService,
    private loginservice: LoginService) { }

  ngOnInit() {
    this.LoadCounselling();

    this.CurrentDeleteCounsellingPlanRequest = new SaveCounsellingPlanRequest();
    this.CurrentDeleteCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }



  ShowList: boolean = true;

  


  BackToCounselling() {
    this.ShowCounselling = true;
    this.ShowMonitoring = false;
    this.Showarrow = false;
  }
  //SelectedPlan: CounsellingPlanController;
    edit(l: CounsellingPlanController) {

    this.CurrentEditCounsellingPlanRequest.Concerns = l.Concerns;
    this.CurrentEditCounsellingPlanRequest.ActorCode = l.ActorCode.toString();
    this.CurrentEditCounsellingPlanRequest.CounsellingDoctor = l.CounsellingDoctor;
      this.CurrentEditCounsellingPlanRequest.CounsellingPlanCode = l.CounsellingPlanCode;
      this.CurrentEditCounsellingPlanRequest.BranchCode = l.BranchCode;
    this.CurrentEditCounsellingPlanRequest.FinancialStatus = l.FinancialStatus;
    this.CurrentEditCounsellingPlanRequest.PackageCost = l.PackageCost;
    this.CurrentEditCounsellingPlanRequest.PlanStatus = l.PlanStatus;
    this.CurrentEditCounsellingPlanRequest.Potential = l.Potential;
    this.CurrentEditCounsellingPlanRequest.RecommendedPackage = l.RecommendedPackage;
    this.CurrentEditCounsellingPlanRequest.SelectEmi = l.SelectEmi;
      this.CurrentEditCounsellingPlanRequest.TreatmentPlan = l.TreatmentPlan;
      //this.CurrentEditCounsellingPlanRequest.CounsellingPlanCode = l.CounsellingPlanCode;
    this.CurrentEditCounsellingPlanRequest.VisitCode = l.VisitCode.toString();
      this.CurrentEditCounsellingPlanRequest.EndDate = l.EndDate;
      this.CurrentEditCounsellingPlanRequest.ActorCode = l.ActorCode.toString();
      this.CurrentEditCounsellingPlanRequest.StartDate = l.StartDate;
      this.CurrentEditCounsellingPlanRequest.BranchCode = l.BranchCode;
    //this.CurrentEditCounsellingPlanRequest.FormattedCode = l.FormattedCode;
    const modalRef = this.modalService.open(NgbEditCounsellingPlanModal,
    {
        centered: true,
        size: "lg"
      })
      modalRef.componentInstance.CurrentEditCounsellingPlanRequest = this.CurrentEditCounsellingPlanRequest;
      modalRef.componentInstance.FormattedCode = l.FormattedCode;
      modalRef.componentInstance.FacilityShortName = l.FacilityShortName;

    modalRef.result.then(x => { this.GetCounsellingPlanController() })
  }
 
  DeleteActivity(l: CounsellingPlanController) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActivity2(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActivity2(l: CounsellingPlanController) {
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    var saveReq: GenericParams = new GenericParams();
    saveReq.ConditionalOperator = 80100;
    saveReq.Params = [
      new FTV('PlanCode', 'number', l.CounsellingPlanCode)
    ];
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 80100;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.LoadCounselling();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }


  ///////////
  //edit(objCategory: any) {
  //  var patient: CounsellingPlanController = objCategory;
  //  if (patient != null) {
  //    this.SelectedPlan = patient;
  //    let options: NgbModalOptions = {
  //      centered: true,
  //      size: "lg"
  //    };
  //    const modalRef = this.modalService.open(NgbEditCounsellingPlanModal, options)
  //    modalRef.componentInstance.FormattedCode = patient.FormattedCode;
  //    this.CurrentEditCounsellingPlanRequest.Concerns = patient.Concerns;
  //    this.CurrentEditCounsellingPlanRequest.ActorCode = patient.ActorCode.toString();
  // this.CurrentEditCounsellingPlanRequest.CounsellingDoctor = patient.CounsellingDoctor;
  //  this.CurrentEditCounsellingPlanRequest.CounsellingPlanCode = patient.CounsellingPlanCode;
  //    this.CurrentEditCounsellingPlanRequest.FinancialStatus = patient .FinancialStatus;
  //    this.CurrentEditCounsellingPlanRequest.PackageCost = patient.PackageCost;
  //    this.CurrentEditCounsellingPlanRequest.PlanStatus = patient.PlanStatus;
  //    this.CurrentEditCounsellingPlanRequest.Potential = patient.Potential;
  //    this.CurrentEditCounsellingPlanRequest.RecommendedPackage = patient.RecommendedPackage;
  //    this.CurrentEditCounsellingPlanRequest.SelectEmi = patient.SelectEmi;
  //    this.CurrentEditCounsellingPlanRequest.StartDate = patient.StartDate;
  //    this.CurrentEditCounsellingPlanRequest.TreatmentPlan = patient.TreatmentPlan;
  //    this.CurrentEditCounsellingPlanRequest.VisitCode = patient.VisitCode.toString();
  //    this.CurrentEditCounsellingPlanRequest.EndDate = patient.EndDate;

  //  }
  //}
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  
  Selectedpatient: CounsellingPlanController;
  Open(objCategory: any) {
    var patient: CounsellingPlanController = objCategory;
    if (patient != null) {
      this.Selectedpatient = patient;
      this.ShowMonitoring = true;
      this.ShowCounselling = false;
      this.Showarrow = true;
    }
    else {
      this.Selectedpatient = null;
    }
  }
  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }
  gotoviewprofile() {
    
    this.router.navigate(['testnurse/profileview']);
  }
  AddPlan() {
    const modalRef = this.modalService.open(NgbCounsellingRegistryModal,
      {
        centered: true,
        size: 'lg'

      })
    
  }

  SearchPatient() {
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg'
      })

    modalRef.result.then((val: string) => {
      //alert(val);
      const modalRef = this.modalService.open(NgbCounsellingRegistryModal,
        {
          centered: true,
          size: 'lg'
        })
      modalRef.componentInstance.FormattedCode = val;
      modalRef.result.then(x => { this.GetCounsellingPlanController()})
    });

  }
 
  del_(CounsellingPlanCode: any) {
   
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(CounsellingPlanCode);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  criteriaChange(value: string) {
    this.RefreshPatients(value);
   
  }
  DeleteActorIdentities(CounsellingPlanCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentDeleteCounsellingPlanRequest.ConditionalOperator = 30;
    this.CurrentDeleteCounsellingPlanRequest.CounsellingPlanCode = 17 ;
    this.CurrentDeleteCounsellingPlanRequest.RecordStatus = "D";
    //this.CurrentDeleteCounsellingPlanRequest.ActorCode = "43572";
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
   //this.CurrentActorDeleteDocRquest.ActorCode = this.SActorCode;
    this.actorservice.SaveCounsellingPlan(this.CurrentDeleteCounsellingPlanRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            //this.ShowList = true;
            this.LoadCounselling();

            this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

}
